import axios from 'axios'

const resBody = (response) => response

const requests = {
  get: (url, config) => axios.get(url, config).then(resBody),
  post: (url, body, config) => axios.post(url, body, config).then(resBody),
  put: (url, body, config) => axios.put(url, body, config).then(resBody),
  del: (url, config) => axios.delete(url, config).then(resBody),
  dynamic: (method, url, body, config) => axios[method](url, body, config).then(resBody)
};

const billing = {
  getBilling: () => requests.get('/customer/billing/getBilling'),
}

const checkout = {
  startBraintree: (body) => requests.post('/customer/checkout/startBraintree', body),
  stripeCheckout: (body) => requests.post('/v1/checkout/payment', body),
  updateStripeCheckout: (body) => requests.post('/v1/checkout/update', body),
  checkoutReview: (body) => requests.post('/v1/checkout/review', body),
  abandonReview: (body) => requests.post('/v1/checkout/abandon/review', body),
  checkoutInfoCollection: (body) => requests.post('/v1/ui/data-collection', body),
  useCredit: (body) => requests.post('/v1/checkout/use-credits', body),
  useCoupon: (body) => requests.post('/v1/checkout/use-coupon', body),
  noPaymentCheckout: (body) => requests.post('/v1/checkout/no-payment', body),
  usageCheckout: (body) => requests.post('/v1/checkout/usage', body),
  startPaypal: (body) => requests.post('/v1/checkout/start-paypal', body),
  requireShippingQuote: (body) => requests.post('/v1/checkout/shipping-quote', body),
  paypalCheckout: (body) => requests.post('/v1/checkout/paypal', body)
};

const shippingCalculator = {
  shipEstimate: (body) => requests.post('/v1/shipping-calculator', body),
  publicEstimate: (body) => requests.post('v1/shipping-calculator/public', body),
  getShippingRequestCleanup: (body) => requests.post('/v1/shipping-calculator/request/cleanup', body),
  getPickupQuote: (body) => requests.post('/v1/shipping-calculator/pickup', body)
}

const email = {
  customerReferralUsed: (body) => requests.post(`/email/referral`, body),
  customerWelcome: (body) => requests.post(`/email/welcome/${body.email}`, body),
  customerAccountDeleteRequest: () => requests.get(`/email/account/delete`),
  passwordReset: (body) => requests.post(`/email/customer/reset/${body.email}`, body)
}

const customer = {
  loginWeb: (body) => requests.post('/customer/web/login', body),
  getUserConfig: () => requests.get('/userConfig'),
  referralUsed: (body) => requests.post('/customer/referral/used', body)
}

const prereceiving = {
  startPreReceiving: (body) => requests.post('/v1/prereceive', body),
}

const pkg = {
  getPackage: ({packageId}) => requests.get(`/customer/packages/getPackage/${packageId}`),
  getPackageShipped: ({ packageId}) => requests.get(`/v1/packages/${packageId}/shipped`),
  getInsuranceCost: ({quoteId}) => requests.get(`/customer/package/insurance/${quoteId}`),
  updatePackage: (body) => requests.post(`/customer/packages/updateInfo`, body),
  getInvoices: ({ packageId}) => requests.get(`/v1/packages/${packageId}/invoices`),
  uploadInvoices: ({ packageId, files }) => {
    const formData = new FormData()
    files.forEach(file => formData.append('files', file))

    return requests.post(
      `/v1/packages/${packageId}/uploadInvoices`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
  },
  deleteInvoice: ({ packageInvoiceId}) => requests.del(`/v1/packages/invoice/${packageInvoiceId}`),
  updatePackageV1: (body) => requests.put(`/v1/packages/${body.packageId}`, body.updateBody),
  dynamicUpdate: (method, url, body) => requests.dynamic(method, url, body),
  returnPackage: (body) => requests.post(`/customer/ship/return`, body),
  updateCustomsType: (body, packageId) => requests.post(`/package/customsType/${packageId}`, body)
}

const items = {
  getItems: ({ packageId, disposition, type }) => requests.get(`/package/items/${packageId}?disposition=${disposition}&type=${type}`),
  updateItem: (body) => requests.put(`/package/item/update`, body),
  addItem: (body) => requests.post(`/package/item/add`, body),
  deleteItem: (body) => requests.post(`/package/item/delete`, body),
}

const timeline = {
  addTimeline: (body) => requests.post('v1/timeline', body)
}

const forex = {
  getForexRates: ({ currency }) => requests.get(`/forex/rates/${currency}`),
}

const address = {
  addAddress: (body) => requests.post('/customer/addresses/addAddress', body),
  updateAddress: (body) => requests.post('/customer/addresses/updateAddress', body),
}

const shippingQuote = {
  uploadPdf: ({quoteId, type, files}) => {
    const formData = new FormData()

    files.forEach(file => formData.append('files', file))
    formData.append('quoteId', quoteId);
    formData.append('type', type);

    return requests.post(`v1/shippingQuote/upload/${quoteId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }}
    )
  }
}

export default {
  billing,
  checkout,
  email,
  customer,
  prereceiving,
  pkg,
  items,
  timeline,
  shippingCalculator,
  forex,
  address,
  shippingQuote
};
